export function formatFullName(title: string, first_name: string, last_name: string) {
  return `${capitalize(title)} ${capitalize(first_name)} ${capitalize(last_name)}`;
}

export function capitalize(word: string): string {
  return word.toLowerCase().replace(/(^.{1})/g, (subString) => subString.toLocaleUpperCase());
}
